import supabase from "./supabase";

// Todo: Function to get tasks for a specific user by empUserId current day
export async function getUserTasks(empUserId) {
  const { data, error } = await supabase
    .from("taskManager")
    .select("*")
    .eq("empUserId", empUserId) // Fetch tasks where empUserId matches
    .single();

  if (error) {
    console.error("Error loading tasks for user:", error);
    throw new Error("Could not load tasks for the user");
  }

  return data;
}

// Todo: get task of current week by empUserId (Monday to Sunday)
export async function getUserTasks_currentWeek(empUserId) {
  const today = new Date();

  // Calculate the start of the week (Monday) based on local time
  const dayOfWeek = today.getDay(); // Get the day of the week (0 = Sunday, 6 = Saturday)
  const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Calculate difference to Monday
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - diffToMonday); // Move to Monday
  startOfWeek.setHours(0, 0, 0, 0); // Set time to the start of the day (local time)

  // Calculate the end of the week (Sunday) based on local time
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6); // Move to Sunday
  endOfWeek.setHours(23, 59, 59, 999); // Set time to the end of the day (local time)

  // Format the dates without converting to UTC
  const startOfWeekISO = `${startOfWeek.getFullYear()}-${String(
    startOfWeek.getMonth() + 1
  ).padStart(2, "0")}-${String(startOfWeek.getDate()).padStart(
    2,
    "0"
  )}T00:00:00`;
  const endOfWeekISO = `${endOfWeek.getFullYear()}-${String(
    endOfWeek.getMonth() + 1
  ).padStart(2, "0")}-${String(endOfWeek.getDate()).padStart(2, "0")}T23:59:59`;

  // Fetch data from Supabase
  const { data, error } = await supabase
    .from("taskManager_history")
    .select("*")
    .eq("empUserId", empUserId) // Fetch tasks where empUserId matches
    .gte("checkinTime", startOfWeekISO) // Filter tasks from the start of the week
    .lte("checkinTime", endOfWeekISO) // Filter tasks up to the end of the week
    .order("checkinTime", { ascending: true }); // Order by checkinTime in ascending order

  if (error) {
    console.error(
      `Error loading tasks for the current week for user ${empUserId}:`,
      error.message
    );
    throw new Error(
      `Could not load tasks for the current week for user ${empUserId}`
    );
  }

  return data;
}

// Todo :Get task for week by Date (Monday to Sunday)
// Function to get tasks for the week of the provided pickDate
export async function getUserTasks_byPickDate(empUserId, pickDate) {
  const selectedDate = new Date(pickDate);

  // Calculate the start of the week (Monday)
  const dayOfWeek = selectedDate.getDay(); // Get the day of the week (0 = Sunday, 6 = Saturday)
  const diffToMonday = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Calculate difference to Monday
  const startOfWeek = new Date(selectedDate);
  startOfWeek.setDate(selectedDate.getDate() - diffToMonday); // Move to Monday
  startOfWeek.setHours(0, 0, 0, 0); // Set time to the start of the day

  // Calculate the end of the week (Sunday)
  const endOfWeek = new Date(startOfWeek);
  endOfWeek.setDate(startOfWeek.getDate() + 6); // Move to Sunday
  endOfWeek.setHours(23, 59, 59, 999); // Set time to the end of the day

  // Format the dates without converting to UTC
  const startOfWeekISO = `${startOfWeek.getFullYear()}-${String(
    startOfWeek.getMonth() + 1
  ).padStart(2, "0")}-${String(startOfWeek.getDate()).padStart(
    2,
    "0"
  )}T00:00:00`;
  const endOfWeekISO = `${endOfWeek.getFullYear()}-${String(
    endOfWeek.getMonth() + 1
  ).padStart(2, "0")}-${String(endOfWeek.getDate()).padStart(2, "0")}T23:59:59`;

  // Fetch data from Supabase
  const { data, error } = await supabase
    .from("taskManager_history")
    .select("*")
    .eq("empUserId", empUserId) // Filter by user ID
    .gte("checkinTime", startOfWeekISO) // Filter tasks from the start of the week (Monday)
    .lte("checkinTime", endOfWeekISO) // Filter tasks up to the end of the week (Sunday)
    .order("checkinTime", { ascending: true }); // Order tasks by check-in time in ascending order

  // Handle errors
  if (error) {
    console.error(
      `Error loading tasks for the selected week for user ${empUserId}:`,
      error.message
    );
    throw new Error(
      `Could not load tasks for the selected week for user ${empUserId}`
    );
  }

  return data;
}

// Todo: Get tasks for the current month by empUserId
export async function getUserTasks_currentMonth(empUserId) {
  const today = new Date();

  // Calculate the start of the month (local time)
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1); // First day of the current month
  startOfMonth.setHours(0, 0, 0, 0); // Set time to the start of the day (local time)

  // Calculate the end of the month (local time)
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0); // Last day of the current month
  endOfMonth.setHours(23, 59, 59, 999); // Set time to the end of the day (local time)

  // Format the dates as local strings for the query
  const startOfMonthISO = `${startOfMonth.getFullYear()}-${String(
    startOfMonth.getMonth() + 1
  ).padStart(2, "0")}-${String(startOfMonth.getDate()).padStart(
    2,
    "0"
  )}T00:00:00`;
  const endOfMonthISO = `${endOfMonth.getFullYear()}-${String(
    endOfMonth.getMonth() + 1
  ).padStart(2, "0")}-${String(endOfMonth.getDate()).padStart(
    2,
    "0"
  )}T23:59:59`;

  const { data, error } = await supabase
    .from("taskManager_history")
    .select("*")
    .eq("empUserId", empUserId) // Fetch tasks where empUserId matches
    .gte("checkinTime", startOfMonthISO) // Filter tasks from the start of the month
    .lte("checkinTime", endOfMonthISO) // Filter tasks up to the end of the month
    .order("checkinTime", { ascending: true }); // Order by checkinTime in ascending order

  if (error) {
    console.error(
      `Error loading tasks for the current month for user ${empUserId}:`,
      error.message
    );
    throw new Error(
      `Could not load tasks for the current month for user ${empUserId}`
    );
  }

  return data;
}

// Function to get tasks for a specific user by empUserId
export async function getUserTasks_history(empUserId) {
  const { data, error } = await supabase
    .from("taskManager_history")
    .select("*")
    .eq("empUserId", empUserId) // Fetch tasks where empUserId matches
    .order("checkinTime", { ascending: true }); // Order by checkinTime in ascending order

  if (error) {
    console.error(`Error loading tasks for user ${empUserId}:`, error.message);
    throw new Error(`Could not load tasks for user ${empUserId}`);
  }

  return data;
}
